import { createFileRoute } from "@tanstack/react-router";
import { CvDocument } from "@/components/blocks/CvDocument";
import { getTranslator } from "@/lib/i18n";
import { resolveLocaleForPath } from "@/lib/i18n/locale";
import { buildSeo } from "@/lib/seo";

export const Route = createFileRoute("/{-$locale}/cv")({
	component: CvDocument,
	loader: ({ location, serverContext }) => ({
		locale: resolveLocaleForPath(location.pathname, serverContext),
	}),
	head: ({ loaderData }) => {
		if (!loaderData) return {};
		const t = getTranslator(loaderData.locale);
		return buildSeo({
			title: t((t) => t.seo.cvTitle),
			description: t((t) => t.seo.cvDescription),
			path: "/cv",
			locale: loaderData.locale,
		});
	},
});
